import Cookies from "js-cookie"
import { useGlobal } from "@/app/store/global.ts"
import type { ICookieAttributes } from "@/entities/auth/types.ts"
import { useAuthStore } from "@/features/auth/model/store.ts"
import type { RequestPagination, Translation } from "@/shared/types/index.ts"
import request from "@/shared/utils/axios.ts"
import queryClient from "../config/query-client.ts"

export const ACCESS_TOKEN_NAME = "__ENERGOSAM_TOKEN__"
export const REFERSH_TOKEN_NAME = "__ENERGOSAM_REFRESH_TOKEN__"

export class Api {
  static getReference(url: string, filters?: object) {
    return (): Promise<RequestPagination<{ translations: Translation }>> =>
      request({
        method: "GET",
        url: url,
        params: filters
      })
  }
}

export class Auth {
  static getToken() {
    return Cookies.get(ACCESS_TOKEN_NAME)
  }

  static setToken(token: string, options?: ICookieAttributes) {
    Cookies.set(ACCESS_TOKEN_NAME, token, options)
  }

  static setRefreshToken(refresh: string, options?: ICookieAttributes) {
    Cookies.set(REFERSH_TOKEN_NAME, refresh, options)
  }

  static clearAuth() {
    Cookies.remove(ACCESS_TOKEN_NAME)
    Cookies.remove(REFERSH_TOKEN_NAME)
  }

  static async logout() {
    Auth.clearAuth()
    useAuthStore.getState().resetAuth()
    useGlobal.getState().reset()
    queryClient.clear()
    window.location.pathname = "/auth/login"
  }
}
